import { ServerError } from '../types';

export type State = ServerError | null;

export const defaultState = null;

const errorReducer = (state: State = defaultState): State => state;

export default errorReducer;
